import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BlogPost } from 'types/Blog';
import { getBlogPosts } from './ActionCreators';

interface BasketState {
  blogPosts: BlogPost[];
  isLoading: boolean;
  error: string;
}

const initialState: BasketState = {
  blogPosts: [],
  isLoading: false,
  error: '',
};

export const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {},
  extraReducers: {
    [getBlogPosts.fulfilled.type]: (
      state,
      action: PayloadAction<BlogPost[]>
    ) => {
      state.isLoading = false;
      state.error = '';
      state.blogPosts = action.payload;
    },
    [getBlogPosts.pending.type]: (state) => {
      state.isLoading = true;
    },
    [getBlogPosts.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default blogSlice.reducer;
